import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import {
  CargaComisionesManualesDispatcher,
  cargaComisionesManualesDispatcher
} from "./CargaComisionesManuales.dispatcher";
import {
  CargaComisionesManualesStore,
  cargaComisionesManualesStore
} from "./CargaComisionesManuales.store";
import CargaComisionesManualesComponent from "../../../components/comisionesManuales/generacion";

interface Props
  extends CargaComisionesManualesStore,
    CargaComisionesManualesDispatcher {}

@ReduxConnect(cargaComisionesManualesStore, cargaComisionesManualesDispatcher)
export default class CargaComisionesManualesContainer extends Component<Props> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Carga de Comisiones Manuales desde Excel" />
          <CargaComisionesManualesComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
